import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'


export default {

    async [actionTypes.FILE_MANAGER.UPLOAD_ARQUIVO](context, dados) {
        await api.fileManager.uploadArquivo(dados)
    },

    async [actionTypes.FILE_MANAGER.BAIXAR_ARQUIVO](context, dados) {
        await api.fileManager.baixarArquivo(dados)
    },

}